import React from 'react';
import Image from 'gatsby-plugin-sanity-image';

import { StandardBlockWrapper } from './standardBlockWrapper';

const GuaranteeItem = ({ image, heading }) => {
  return (
    <div>
      {image && <Image {...image} width="600" className="w-24 mx-auto lg:w-28" />}
      {heading && <h4 className="text-lg text-center max-w-s mt-6">{heading}</h4>}
    </div>
  );
};

const GuaranteesGrid = ({ heading, padding, items, backgroundColor }) => {
  return (
    <StandardBlockWrapper padding={padding} backgroundColor={backgroundColor}>
      <h2 className="font-display text-4xl text-center">{heading}</h2>
      {items.length && (
        <div className="grid grid-cols-2 px-gutter mt-6 md:mt-24 gap-4 w-full md:grid-cols-5 max-w-screen-xl mx-auto">
          {items.map((item) => (
            <GuaranteeItem {...item} />
          ))}
        </div>
      )}
    </StandardBlockWrapper>
  );
};

export default GuaranteesGrid;
